module.exports = __webpack_public_path__ + "img/casa_mendigo.7985bace.webp";